import { render, staticRenderFns } from "./AcademicPrograms.vue?vue&type=template&id=26cb9010&scoped=true&"
import script from "./AcademicPrograms.vue?vue&type=script&lang=js&"
export * from "./AcademicPrograms.vue?vue&type=script&lang=js&"
import style0 from "./AcademicPrograms.vue?vue&type=style&index=0&id=26cb9010&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb9010",
  null
  
)

export default component.exports